<div class="print-content no-print-flexbox ftp-content internal" #pdfPage *ngIf="!loading">
  <div layout="column" class="page">
    <div class="page-break"></div>

    <div class="report-header">
      <img src="{{ logoUrl }}" class="ftp-logo" />
      <div>
        <h2 class="ftp-title">{{ reportTitle }}</h2>
      </div>
    </div>
    <hr />
    <div class="margin-10-left">
      <div style="margin-top: 10px; line-height: 1.6">
        <div class="header-style">
          <div class="header-class">Test Name</div>
          <div class="value-font">
            {{ requestInfo.testName }}
          </div>
        </div>
        <div class="header-style">
          <div class="header-class">Test Mode</div>
          <div class="value-font">
            {{ requestInfo.mode }}
          </div>
        </div>
        <div class="header-style">
          <div class="header-class">Start Date</div>
          <div class="value-font">{{ startDate }}</div>
        </div>
        <div class="header-style">
          <div class="header-class">End Date</div>
          <div class="value-font">{{ stopDate }}</div>
        </div>
        <div class="header-style">
          <div class="header-class">Duration</div>
          <div class="value-font">{{ duration }}</div>
        </div>
        <div class="header-style" *ngIf="overallConfiguration">
          <div class="header-class">Test Points</div>
          <div class="value-font">
            {{ overallConfiguration.agent.primary.id }}
          </div>
        </div>
        <div
          class="header-style"
          *ngIf="
            overallConfiguration &&
            overallConfiguration.agent.secondary &&
            overallConfiguration.agent.secondary.length > 0
          "
        >
          <div class="header-class"></div>
          <div
            class="value-font"
            *ngIf="
              overallConfiguration &&
              overallConfiguration.agent.secondary &&
              overallConfiguration.agent.secondary.length > 0
            "
          >
            {{ overallConfiguration.agent.secondary[0].id }}
          </div>
        </div>
      </div>
      <div
        *ngIf="
          requestInfo?.customerInfo?.name ||
          requestInfo?.customerInfo?.contact ||
          requestInfo?.customerInfo?.phone ||
          requestInfo?.customerInfo?.email
        "
      >
        <div class="reports-customer-info">
          <div class="info-title">Customer</div>
          <div class="info-container">
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.name">
              <div class="sec-header">Name</div>
              <div class="sec-value">{{ requestInfo.customerInfo.name }}</div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.contact">
              <div class="sec-header">Contact</div>
              <div class="sec-value">{{ requestInfo.customerInfo.contact }}</div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.email">
              <div class="sec-header">Email</div>
              <div class="sec-value">{{ requestInfo.customerInfo.email }}</div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.customerInfo?.phone">
              <div class="sec-header">Phone</div>
              <div class="sec-value">{{ requestInfo.customerInfo.phone }}</div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="requestInfo?.techInfo?.name || requestInfo?.techInfo?.id">
        <div class="reports-customer-info">
          <div class="info-title">Technician</div>
          <div class="info-container">
            <div class="details-sec" *ngIf="requestInfo?.techInfo?.name">
              <div class="sec-header">Name</div>
              <div class="sec-value">
                {{ requestInfo.techInfo?.name }}
              </div>
            </div>
            <div class="details-sec" *ngIf="requestInfo?.techInfo?.id">
              <div class="sec-header">ID</div>
              <div class="sec-value">
                {{ requestInfo.techInfo?.id }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 30px" *ngIf="requestInfo?.comments">
        <div class="header-style">
          <div class="header-class">Comments</div>
          <div class="value-font">
            {{ requestInfo.comments }}
          </div>
        </div>
      </div>
    </div>
    <hr />
    <h4 class="walk-header" *ngIf="overallVerdict === 'PASS'">
      Test Results - <span class="test-pass">Test Passed</span>
      <span class="test-warning" *ngIf="upstreamSummary.tcpLow || downstreamSummary.tcpLow"
        >with warnings</span
      >
    </h4>
    <h4 class="walk-header" *ngIf="overallVerdict === 'FAIL'">
      Test Results - <span class="test-fail">Test Failed</span>
    </h4>
    <div class="flex">
      <div class="walk-chart">
        <nrwl-trending-chart [options]="bulletChartOptions" id="bulletChart"></nrwl-trending-chart>
        <div class="label">Mbps</div>
      </div>
      <div>
        <div
          layout="row"
          class="legend-row report-header"
          *ngIf="
            configuration.direction === 'engine-a-to-engine-b' ||
            configuration.direction === 'bidirsequential'
          "
        >
          <span flex></span>
          <md-icon
            class="material-icons md-30 retrans-frames-icon diagnosis-head-left upstream-legend"
            >stop</md-icon
          >
          <span
            class="walk-chart-legend-text"
            *ngIf="
              configuration.direction === 'engine-a-to-engine-b' ||
              configuration.direction === 'bidirsequential'
            "
            >Upload Throughput
          </span>
        </div>
        <div
          layout="row"
          class="report-header"
          *ngIf="
            configuration.direction === 'engine-b-to-engine-a' ||
            configuration.direction === 'bidirsequential'
          "
        >
          <span flex></span>
          <md-icon
            class="material-icons md-30 throughput-icon diagnosis-head-left downstream-legend"
            >stop</md-icon
          >
          <span
            class="walk-chart-legend-text"
            *ngIf="
              configuration.direction === 'engine-b-to-engine-a' ||
              configuration.direction === 'bidirsequential'
            "
            >Download Throughput
          </span>
        </div>

        <div layout="row" class="report-header">
          <span flex></span>
          <md-icon
            class="material-icons md-30 retrans-frames-icon diagnosis-head-left walk-target-legend"
            >stop</md-icon
          >
          <span class="walk-chart-legend-text">Threshold Throughput</span>
        </div>
      </div>
    </div>
    <div class="test-result-table-panel">
      <table class="test-result-table">
        <tr>
          <th class="empty-column"></th>
          <th
            *ngIf="
              configuration.direction === 'engine-a-to-engine-b' ||
              configuration.direction === 'bidirsequential'
            "
            class="upstream-row"
          >
            Upload
          </th>
          <th
            class="downstream-row"
            *ngIf="
              configuration.direction === 'engine-b-to-engine-a' ||
              configuration.direction === 'bidirsequential'
            "
          >
            Download
          </th>
        </tr>
        <tr>
          <td class="transperant-column">Verdict</td>
          <td
            class="upstream-column"
            *ngIf="
              configuration.direction === 'engine-a-to-engine-b' ||
              configuration.direction === 'bidirsequential'
            "
          >
            <span [ngClass]="{ 'fail-verdict': upstreamSummary.verdict === 'FAIL' }">{{
              upstreamSummary.verdict
            }}</span>
            <span class="verdict-result" *ngIf="configuration?.thresholdnEabled">
              The throughput is
              <span *ngIf="upstreamSummary.verdict === 'FAIL'">less</span>
              <span *ngIf="upstreamSummary.verdict === 'PASS'">more</span>
              than the threshold</span
            >
          </td>
          <td
            class="downstream-column"
            *ngIf="
              configuration.direction === 'engine-b-to-engine-a' ||
              configuration.direction === 'bidirsequential'
            "
          >
            <span [ngClass]="{ 'fail-verdict': downstreamSummary.verdict === 'FAIL' }">
              {{ downstreamSummary.verdict }}</span
            >
            <span class="verdict-result" *ngIf="configuration?.thresholdnEabled">
              The throughput is
              <span *ngIf="downstreamSummary.verdict === 'FAIL'">less</span>
              <span *ngIf="downstreamSummary.verdict === 'PASS'">more</span>
              than the threshold</span
            >
          </td>
        </tr>
        <tr *ngIf="upstreamSummary.threshold || downstreamSummary.threshold">
          <td class="transperant-column">Threshold throughput (L1)</td>
          <td
            *ngIf="
              configuration.direction === 'engine-a-to-engine-b' ||
              configuration.direction === 'bidirsequential'
            "
            class="upstream-column"
          >
            {{ upstreamSummary.threshold }} Mbps
          </td>
          <td
            class="downstream-column"
            *ngIf="
              configuration.direction === 'engine-b-to-engine-a' ||
              configuration.direction === 'bidirsequential'
            "
          >
            {{ downstreamSummary.threshold }} Mbps
          </td>
        </tr>
        <tr *ngIf="upstreamSummary.target || downstreamSummary.target">
          <td class="transperant-column">Target throughput (L4)</td>
          <td
            *ngIf="
              configuration.direction === 'engine-a-to-engine-b' ||
              configuration.direction === 'bidirsequential'
            "
            class="upstream-column"
          >
            {{ upstreamSummary.target }} Mbps
          </td>
          <td
            class="downstream-column"
            *ngIf="
              configuration.direction === 'engine-b-to-engine-a' ||
              configuration.direction === 'bidirsequential'
            "
          >
            {{ downstreamSummary.target }} Mbps
          </td>
        </tr>
        <tr>
          <td class="transperant-column">Average throughput (L4)</td>
          <td
            *ngIf="
              configuration.direction === 'engine-a-to-engine-b' ||
              configuration.direction === 'bidirsequential'
            "
            class="upstream-column"
          >
            {{ upstreamSummary.bestAvg }} Mbps
          </td>
          <td
            class="downstream-column"
            *ngIf="
              configuration.direction === 'engine-b-to-engine-a' ||
              configuration.direction === 'bidirsequential'
            "
          >
            {{ downstreamSummary.bestAvg }} Mbps
          </td>
        </tr>
        <tr>
          <td class="transperant-column">Peak throughput (L4)</td>
          <td
            *ngIf="
              configuration.direction === 'engine-a-to-engine-b' ||
              configuration.direction === 'bidirsequential'
            "
            class="upstream-column"
          >
            {{ upstreamSummary.bestPeak }} Mbps
          </td>
          <td
            class="downstream-column"
            *ngIf="
              configuration.direction === 'engine-b-to-engine-a' ||
              configuration.direction === 'bidirsequential'
            "
          >
            {{ downstreamSummary.bestPeak }} Mbps
          </td>
        </tr>
        <tr>
          <td class="rtt-column">RTT <span class="normal-font">(round trip time)</span></td>

          <td colspan="2" class="rowspan-2-transperant-colunn">{{ testSummary.rttBase }} ms</td>
        </tr>
      </table>
    </div>
  </div>
  <div layout="column" class="page">
    <div class="page-break"></div>
    <span class="page-title"> FTP Test Configs </span>
    <nrwl-report-view-table
      [dataSource]="testConfigsDataSource"
      [displayedColumns]="displayedColumns"
    ></nrwl-report-view-table>
  </div>
  <div layout="column" class="page">
    <div class="page-break"></div>
    <span class="page-title"> Ftp Test Results </span>
    <nrwl-report-view-table
      [dataSource]="testResultsDataSource"
      [displayedColumns]="displayedColumns"
    ></nrwl-report-view-table>
  </div>
  <div layout="column">
    <div *ngFor="let windowResult of windowSummary">
      <div class="page" layout="column">
        <div class="page-break"></div>

        <span class="page-title">
          {{ windowResult.direction }} Window Test
          {{ windowResult.index }}
        </span>

        <nrwl-report-view-table
          [dataSource]="getwindowResultDataSource(windowResult)"
          [displayedColumns]="displayedColumns"
        ></nrwl-report-view-table>

        <!--Throughput/Retransmit Chart -->
        <div layout="column" *ngIf="dataAvailable" class="trending-chart-container">
          <div class="column-line-chart-margin">
            <nrwl-trending-chart
              [options]="
                transformService.createTrendingColumnAndLineChart(
                  isThinClientTest,
                  configuration,
                  getMatchedWindowResult(windowResult['window-id']),
                  'retrans_frame',
                  windowResult.direction
                )
              "
              id="window  {{ windowResult['window-id'] }} ThroughputRetransmit"
            ></nrwl-trending-chart>
          </div>
        </div>
      </div>

      <div class="page" layout="column">
        <div class="page-break"></div>

        <!--Throughput/RetrainsRatio Chart -->
        <div layout="column" *ngIf="dataAvailable" class="trending-chart-container">
          <div class="column-line-chart-margin">
            <nrwl-trending-chart
              [options]="
                transformService.createTrendingColumnAndLineChart(
                  isThinClientTest,
                  configuration,
                  getMatchedWindowResult(windowResult['window-id']),
                  'retrans_ratio',
                  windowResult.direction
                )
              "
              id="window  {{ windowResult['window-id'] }} ThroughputRetransmitRatio"
            ></nrwl-trending-chart>
          </div>
        </div>

        <!--Throughput/RTT Chart -->
        <div layout="column" *ngIf="dataAvailable" class="trending-chart-container">
          <div class="column-line-chart-margin">
            <nrwl-trending-chart
              [options]="
                transformService.createTrendingColumnAndLineChart(
                  isThinClientTest,
                  configuration,
                  getMatchedWindowResult(windowResult['window-id']),
                  'rtt',
                  windowResult.direction
                )
              "
              id="window  {{ windowResult['window-id'] }} ThroughputRtt"
            ></nrwl-trending-chart>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    fxLayout="column"
    class="page"
    fxLayoutGap="16px"
    *ngIf="reportmessage && reportmessage?.length !== 0"
  >
    <div class="page-break"></div>

    <mat-toolbar class="diagnosis-head border">
      <div class="mat-toolbar-tools">
        <h2 class="mat-flex">Report Message</h2>
      </div>
    </mat-toolbar>

    <mat-card class="border" fxLayout="column" fxLayoutGap="16px">
      <div fxLayout="row">
        <span>{{ reportmessage }}</span>
      </div>
    </mat-card>
  </div>
</div>
<div class="ftp-content">
  <div class="loader-content" *ngIf="loading">
    <div class="spinner">
      <mat-spinner [diameter]="60"></mat-spinner>
    </div>
    <div class="loader-text">
      <div class="text-message">Getting Reports</div>
    </div>
  </div>
</div>
